import { put, call } from 'redux-saga/effects';
import { HomeCreateAPI, HomeSearchAPI, HomeUpdateAPI } from 'src/api/HomeApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { HOME_ACTIONS } from '../actions/HomeActions';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(HomeSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: HOME_ACTIONS.HOME_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: HOME_ACTIONS.HOME_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({ _id }) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(HomeSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: HOME_ACTIONS.HOME_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(HomeCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        }));

        
        yield put({
            type: HOME_ACTIONS.HOME_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: HOME_ACTIONS.HOME_UPSERT_ERROR,
        });
    }
}

function* update(HomeId, payload) {
    try {
        yield call(HomeUpdateAPI, {
            HomeId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));

        yield edit({ _id: HomeId });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: HOME_ACTIONS.HOME_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(HOME_ACTIONS.HOME_SEARCH, search),
    takeFirstSagaUtil(HOME_ACTIONS.HOME_UPSERT, upsert),
    takeFirstSagaUtil(HOME_ACTIONS.HOME_EDIT, edit),
];
